import Service from "./service.abstract";

export default class ProfileSearchService extends Service {
  constructor(url: string) {
    super();
    this.url = url;
    this.displayDefaultError = false;
  }
}